<template>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
    >
        <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
        ></v-text-field>
        <v-btn
            :disabled="!valid || isFetch"
            color="success"
            class="mr-4"
            @click="onInvite"
        >
            Отправить приглашение
        </v-btn>
    </v-form>
</template>
<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
}
</style>
<script>
import {mapActions, mapGetters} from "vuex";
import * as api from '@/api/workspace';
export default {
    components: {},
    name: 'WorkSpaceInviteForm',
    props:{},
    data() {
        return {
            isFetch: false,
            valid: true,
            email: '',
            emailRules: [
                v => !!v || 'E-mail обязателен к заполнению',
                v => /.+@.+\..+/.test(v) || 'E-mail не валиден',
            ],
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR', 'SHOW_RESPONSE_ERROR']),
        async onInvite(){
            if( ! this.$refs.form.validate() ){
                return Promise.reject();
            }
            this.isFetch = true;
            try {
                let {data} = await api.inviteUser(this.ID_WORK_SPACE, this.email);
                this.SHOW_SUCCESS(data.message);
                this.$refs.form.reset()
                this.$emit('sent', {email: this.email});
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка отправления приглашения. Повторите попытку позже'});
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        }
    },
    computed:{
        ...mapGetters('workspace', ['ID_WORK_SPACE']),
    }
}
</script>